module.exports = __webpack_public_path__ + "img/DK32776655.e81c5364.png";